export var SectionType;
(function (SectionType) {
    SectionType["ad"] = "ad";
    SectionType["button"] = "button";
    SectionType["divider"] = "divider";
    SectionType["follow"] = "follow";
    SectionType["footer"] = "footer";
    SectionType["image"] = "image";
    SectionType["link"] = "link";
    SectionType["logo"] = "logo";
    SectionType["mix"] = "mix";
    SectionType["music"] = "music";
    SectionType["subscribe"] = "subscribe";
    SectionType["html"] = "html";
    SectionType["text"] = "text";
    SectionType["video"] = "video";
    SectionType["topSpacer"] = "topSpacer";
    SectionType["bottomSpacer"] = "bottomSpacer";
    SectionType["placeholder"] = "placeholder";
})(SectionType || (SectionType = {}));
export var ButtonAlign;
(function (ButtonAlign) {
    ButtonAlign["center"] = "center";
    ButtonAlign["left"] = "left";
    ButtonAlign["right"] = "right";
})(ButtonAlign || (ButtonAlign = {}));
//# sourceMappingURL=types.js.map